import { emptyEnergyAlertSettings, EnergyAlertSettingsResponse } from "../pages/customer/energy-management/models/energy-alert-settings-response";
import { SaveEnergyAlertRequest } from "../pages/customer/energy-management/models/save-energy-alert-request";
import { apiSlice } from "../stores/base/api-slice";

const energyAlertsEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getEnergyAlertSettings: builder.query<EnergyAlertSettingsResponse, void>({
			queryFn: async (_arg, _api, _extraOptions, baseQuery) => {
				const result = await baseQuery({
					url: "/vending/unit-threshold-configuration",
					method: "GET",
				});
				if (result.error) {
					const status = result.error.status;
					const data = result.error.data;
					const title = (typeof data === "string" ? data : (data as { title?: string } | null)?.title ?? "").toLowerCase();
					const notConfigured = status === 404 || (status === 400 && title.includes("not found"));
					if (notConfigured) {
						return { data: emptyEnergyAlertSettings };
					}
					return { error: result.error };
				}
				return { data: result.data as EnergyAlertSettingsResponse };
			},
			providesTags: ["EnergyAlerts"],
		}),
		saveEnergyAlertConfiguration: builder.mutation<EnergyAlertSettingsResponse, SaveEnergyAlertRequest>({
			query: body => ({
				url: "/vending/unit-threshold-configuration",
				method: "PUT",
				body,
			}),
			invalidatesTags: ["EnergyAlerts"],
		}),
	}),
});

export const { useLazyGetEnergyAlertSettingsQuery, useSaveEnergyAlertConfigurationMutation } = energyAlertsEndpoints;
